<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  table: {
    type: Object,
    required: true,
  },
  count: {
    type: Number,
    required: false,
  },
});

const page = computed(() => props.table.getState().pagination.pageIndex + 1);

const pageSize = computed(() => props.table.getState().pagination.pageSize);

const count = computed(() =>
  props.count ? props.count : props.table.getCoreRowModel().rows.length,
);
</script>

<template>
  <span v-if="props.table.getPageCount() > 1" class="text-sm">
    {{
      t("all.label.pageInfo", {
        firstEntry: page * pageSize - pageSize + 1,
        lastEntry: Math.min(page * pageSize, count),
        totalEntries: count,
      })
    }}
  </span>
</template>
